module.exports = __webpack_public_path__ + "assets/img/gar5-11.a56efc41.jpg";